import CASL from '@/utils/constants/casl'

export default [
  {
    path: 'tnc',
    name: 'web-content.tnc',
    meta: {
      title: 'Term and Condition',
      action: 'read',
      subject: CASL.ACCESS.TNC
    },
    component: () => import('./TermConditionPage.vue')
  }
]
